import styles from './BenefitsSection.module.css';
import { FaTrophy, FaGlobeAmericas, FaBrain, FaMoneyBillAlt, FaRocket } from 'react-icons/fa';

export default function BenefitsSection() {
  const benefits = [
    {
      title: "Ownership",
      description: "Own real products from day 1",
      icon: <FaTrophy className={styles.benefitIcon} />
    },
    {
      title: "Flexibility",
      description: "Remote freedom + coworking at HQ (Pune)",
      icon: <FaGlobeAmericas className={styles.benefitIcon} />
    },
    {
      title: "Mentorship",
      description: "Access to visionary leadership & mentors",
      icon: <FaBrain className={styles.benefitIcon} />
    },
    {
      title: "Compensation",
      description: "Competitive pay & core team equity",
      icon: <FaMoneyBillAlt className={styles.benefitIcon} />
    },
    {
      title: "Growth",
      description: "Learn fast, build faster, make real impact",
      icon: <FaRocket className={styles.benefitIcon} />
    }
  ];

  return (
    <section className={styles.benefitsSection}>
      <div className={styles.benefitsContent}>
        <h2 className={styles.sectionTitle}>What You Get if You Join Us</h2>
        <div className={styles.benefitsGrid}>
          {benefits.map((benefit, index) => (
            <div key={index} className={styles.benefitCard}>
              <div className={styles.iconContainer}>{benefit.icon}</div>
              <h3 className={styles.benefitTitle}>{benefit.title}</h3>
              <p className={styles.benefitDesc}>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}